import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import QuizIcon from "@mui/icons-material/Quiz";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useNavigate } from "react-router-dom";

const ACTIONS = [
  { icon: AddCircleOutlineIcon,   label: "Create Course",      to: "/admin/course",                bg: "#ede9fe", fg: "#7c3aed" },
  { icon: AssignmentTurnedInIcon, label: "Allocate Resources", to: "/admin/resource-allocation",   bg: "#fff7ed", fg: "#ea580c" },
  { icon: PersonAddIcon,          label: "Add Student",        to: "/admin/student/add",           bg: "#dbeafe", fg: "#2563eb" },
  { icon: QuizIcon,               label: "Create Exam",        to: "/admin/course-test",           bg: "#dcfce7", fg: "#16a34a" },
  { icon: CampaignIcon,           label: "Send Announcement",  to: "/admin/announcements",         bg: "#fce7f3", fg: "#db2777" },
  { icon: AccessTimeIcon,         label: "Add Time Slot",      to: "/admin/timeslot",              bg: "#cffafe", fg: "#0891b2" },
  { icon: GroupAddIcon,           label: "Assign Tutor",       to: "/admin/resource-allocation",   bg: "#e0e7ff", fg: "#4338ca" },
];

export default function QuickActions() {
  const nav = useNavigate();
  return (
    <Grid container spacing={1}>
      {ACTIONS.map((a) => {
        const Icon = a.icon;
        return (
          <Grid item xs={4} key={a.label}>
            <Box
              onClick={() => nav(a.to)}
              sx={{
                bgcolor: a.bg,
                color: a.fg,
                borderRadius: 2,
                p: 1.2,
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Icon sx={{ fontSize: 28 }} />
              <Typography variant="caption" mt={0.5} fontWeight={600} sx={{ color: a.fg, lineHeight: 1.2 }}>
                {a.label}
              </Typography>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
